module.exports = __webpack_public_path__ + "static/media/placeholder.3469a1f8.jpg";